/* eslint-disable fp/no-delete */
// TODO: purify this module
import { cloneDeep, merge } from 'lodash';
import type { Decoration, LinkData, MentionData } from 'ricos-schema';
import { Decoration_Type } from 'ricos-schema';

import { parseLink } from '../../nodeUtils';
import { FROM_RICOS_DECORATION_TYPE, TO_RICOS_DECORATION_DATA_FIELD } from '../consts';

export const convertDecorationToDraftData = (decoration: Decoration) => {
  const { type } = decoration;
  const dataFieldName = TO_RICOS_DECORATION_DATA_FIELD[FROM_RICOS_DECORATION_TYPE[type]];
  return convertDecorationDataToDraft(type, decoration[dataFieldName]);
};

export const convertDecorationDataToDraft = (decorationType: Decoration_Type, data) => {
  const converters = {
    [Decoration_Type.MENTION]: convertMentionData,
    [Decoration_Type.LINK]: convertLinkData,
  };
  if (decorationType in converters) {
    const convert = converters[decorationType];
    const newData = cloneDeep(data);
    convert(newData);
    return newData;
  }
  return data;
};

const convertMentionData = (data: Partial<MentionData> & { mention }) => {
  data.mention = { slug: data.slug, name: data.name, id: data.id };
  delete data.name;
  delete data.slug;
  delete data.id;
};

const convertLinkData = (
  data: LinkData & {
    url?: string;
    target?: string;
    rel?: string;
    anchor?: string;
    customData?: string;
  }
) => {
  if (data.link) {
    const { url, target, anchor, rel, customData } = parseLink(data.link);
    data.url = url;
    if (target) {
      data.target = target;
    }
    if (rel) {
      data.rel = rel;
    }
    if (anchor) {
      data.anchor = anchor;
    }
    if (customData) {
      const customDataObj = parseLinkCustomData(customData);
      merge(data, customDataObj);
    }
    delete data.link;
  }
};

const parseLinkCustomData = (customData: string) => {
  try {
    return { customData: JSON.parse(customData) };
  } catch (e) {
    console.error('failed to parse customData', customData); // eslint-disable-line
    return { customData };
  }
};
